<div class="mb-3" [class.invalid-feedback]="showError">
  <button nbButton type="button" i18n="@@SetTemlateMapping" size="tiny" status="primary" (click)="defineTemplateMapping()">Определить маппинг</button>
</div>
